<template>
  <div class="location">
    <div>{{ fieldValue }}</div>
  </div>
</template>

<script>
export default {
  name: 'location',
  props: ['value', 'disabled', 'widget'],
  computed: {
    fieldValue() {
      return this.location.formatted_address || '暂无定位或定位失败'
    },
  },
  data() {
    return {
      location: {
        addressComponent: null,
        formatted_address: null,
        position: null,
        isPlaceSearch: false,
        placeSearch: null,
      },
    }
  },
  created() {},
  watch: {
    location: {
      deep: true,
      handler: function (val) {
        this.$emit('input', val)
      },
    },
    value: {
      deep: true,
      immediate: true,
      handler: function (val) {
        Object.assign(this.location, val)
      },
    },
  },
}
</script>

<style></style>
